import React, { useState, useEffect, useRef } from 'react'
import { convert_name } from '../../../utils/conversion'

const SelectInput = React.forwardRef(
  (
    {
      label,
      name,
      options,
      required,
      error,
      search,
      onChange,
      value,
      placeholder,
      disabled,
      ...rest
    },
    ref
  ) => {
    const [isOpen, setIsOpen] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [filteredOptions, setFilteredOptions] = useState(options)
    const dropdownRef = useRef(null)
    const inputRef = useRef(null)

    const errorClass = 'border-red-500'

    useEffect(() => {
      if (search) {
        const filtered = options.filter((option) => {
          const unsignedOption = convert_name({
            name: option.label,
          }).toLowerCase()

          return unsignedOption.includes(
            convert_name({ name: searchTerm }).toLowerCase()
          )
        })
        setFilteredOptions(filtered.slice(0, 10))
      } else {
        setFilteredOptions(options)
      }
    }, [searchTerm, options, search])

    useEffect(() => {
      const handleClickOutside = (event) => {
        if (
          dropdownRef.current &&
          !dropdownRef.current.contains(event.target)
        ) {
          setIsOpen(false)
        }
      }

      document.addEventListener('mousedown', handleClickOutside)
      return () => {
        document.removeEventListener('mousedown', handleClickOutside)
      }
    }, [])

    const handleSelectChange = (e) => {
      if (onChange) {
        onChange(e)
      }
      setIsOpen(false)
      setSearchTerm('')
    }

    const handleOptionClick = (optionValue) => {
      const event = {
        target: {
          name,
          value: optionValue,
        },
      }
      handleSelectChange(event)
    }

    const selectedOption = options.find((option) => option.value == value)
    const handleInputFocus = () => {
      setIsOpen(true)
      if (inputRef.current) {
        inputRef.current.select()
      }
    }

    return (
      <section>
        <label
          htmlFor={name}
          className="mb-1 block text-sm font-bold text-black"
        >
          {label} {required && <span className="text-red-accent">*</span>}
        </label>
        <div className="relative" ref={dropdownRef}>
          <div className="relative">
            <input
              ref={inputRef}
              disabled={disabled}
              type="text"
              className={`focus:shadow-outline w-full appearance-none rounded-md border border-gray-400 px-4 py-3 leading-tight text-gray-700 shadow focus:outline-none ${
                error && errorClass
              }`}
              placeholder={
                selectedOption
                  ? selectedOption.label
                  : placeholder
                    ? placeholder
                    : 'Vui lòng chọn một'
              }
              value={
                isOpen ? searchTerm : selectedOption ? selectedOption.label : ''
              }
              onChange={(e) => setSearchTerm(e.target.value)}
              onFocus={handleInputFocus}
              readOnly={!search}
            />
          </div>
          {isOpen && (
            <ul className="absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded-md bg-white shadow-lg">
              {filteredOptions.map((option, index) => (
                <li
                  key={index}
                  className="cursor-pointer px-4 py-2 hover:bg-gray-100"
                  onClick={() => handleOptionClick(option.value)}
                >
                  {option.label}
                </li>
              ))}
              {/* {search &&
                filteredOptions.length === 10 &&
                options.length > 10 && (
                  <li className="px-4 py-2 italic text-gray-500">
                    Showing top 10 results. Keep typing to refine search.
                  </li>
                )} */}
            </ul>
          )}
        </div>
        {error && <p className="mt-1 text-sm text-red-500">{error?.message}</p>}
      </section>
    )
  }
)

export default SelectInput
